import axios from "axios";

const api = axios.create({
  baseURL: "http://127.0.0.1:8000",
  withCredentials: true,
});

function getXsrfToken() {
  const cookie = document.cookie
    .split("; ")
    .find((cookie) => cookie.startsWith("XSRF-TOKEN="));

  if (!cookie) {
    return null;
  }

  return decodeURIComponent(cookie.split("=")[1]);
}

api.interceptors.request.use((config) => {
  const method = config.method?.toLowerCase();

  const precisaCsrf = [
    "post",
    "put",
    "patch",
    "delete",
  ].includes(method);

  if (precisaCsrf) {
    const token = getXsrfToken();

    if (token) {
      config.headers["X-XSRF-TOKEN"] = token;
    }
  }

  return config;
});

export default api;